import { getEnv, getRegion } from '@adsk/acs-sc-web-platform-api';

import { envConfig } from '../consts';

const getAssetUrl = (projectId: string, assetId: string): string =>
  `${
    envConfig[getRegion()][getEnv()].assetsFrontend
  }/${projectId}/assets?assetId=${assetId}`;

export default getAssetUrl;
